/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
    {
        url: '/users',
        name: 'Utilisateurs',
        slug: 'users',
        icon: 'fas fa-users',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/companies',
        name: 'Entreprises',
        slug: 'companies',
        icon: 'fas fa-building',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/programs',
        name: 'Programmes',
        slug: 'programs',
        icon: 'fas fa-city',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/prescribers',
        name: 'Prescripteurs',
        slug: 'prescribers',
        icon: 'fas fa-user-friends',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/customers',
        name: 'Prospects / Clients',
        slug: 'customers',
        icon: 'fas fa-user',
        iconPack: 'fas',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/denounces',
        name: 'Dénonces',
        slug: 'denounces',
        icon: 'BriefcaseIcon',
        roles: ['ROLE_ADMIN'],
        tagColor: 'success',
    },

    {
        url: '/prospects',
        name: 'Prospects',
        slug: 'prospects',
        icon: 'FileIcon',
        roles: ['ROLE_PRESCRIBER'],
    },
    {
        url: '/options',
        name: 'Options',
        slug: 'options',
        icon: 'SettingsIcon',
        roles: ['ROLE_ADMIN', 'ROLE_PRESCRIBER'],
    },
    {
        url: '/bookings',
        name: 'Réservations',
        slug: 'bookings',
        icon: 'BookmarkIcon',
        roles: ['ROLE_ADMIN', 'ROLE_PRESCRIBER'],
    },
    {
        url: '/notifications',
        name: 'Notifications',
        slug: 'notifications',
        icon: 'BellIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/invoices',
        name: 'Factures',
        slug: 'invoices',
        icon: 'DollarSignIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/payments',
        name: 'Paiement Accès',
        slug: 'payments',
        icon: 'CreditCardIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/contrats',
        name: 'Contrats',
        slug: 'contrats',
        icon: 'FileTextIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/articles',
        name: 'Articles',
        slug: 'articles',
        icon: 'ShoppingCartIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/automatisation',
        name: 'Automatisation',
        slug: 'automatisation',
        icon: 'ActivityIcon',
        roles: ['ROLE_ADMIN'],
    },
    {
        url: '/subscriptions',
        name: 'Abonnement',
        slug: 'subscriptions',
        icon: 'CalendarIcon',
        roles: ['ROLE_ADMIN'],
    },
];
